import type {
  SettingItemConfig,
  SettingItemValue,
  SettingsConfig,
  SettingSectionConfig,
} from '../lib/settingStore/settingsConfigSchema.ts'

export const APPEARANCE_COLOR_THEME_SETTING = {
  description: 'Specify the app color theme',
  type: 'string',
  default: 'light',
  options: [
    { label: 'Light', value: 'light' },
    { label: 'Dark', value: 'dark' },
    { label: 'System', value: 'system' },
  ],
} as const satisfies SettingItemConfig

export type AppearanceColorThemeSettingItem =
  typeof APPEARANCE_COLOR_THEME_SETTING
export type AppearanceColorThemeSettingItemValue =
  SettingItemValue<AppearanceColorThemeSettingItem>

export const INTERNAL_TOOLS_APPEARANCE_SETTING_SECTION = {
  items: {
    'appearance.colorTheme': APPEARANCE_COLOR_THEME_SETTING,
  },
} as const satisfies SettingSectionConfig

export const INTERNAL_TOOLS_FEATURE_FLAG_SETTING_SECTION = {
  items: {
    'featureFlags.developer.debugMode': {
      description: 'Show debug information',
      type: 'boolean',
      default: false,
    },
  },
} as const satisfies SettingSectionConfig

export const DEFAULT_INTERNAL_TOOLS_SETTINGS = {
  settingsId: 'default-internal-tools',
  sections: {
    appearance: INTERNAL_TOOLS_APPEARANCE_SETTING_SECTION,
    featureFlags: INTERNAL_TOOLS_FEATURE_FLAG_SETTING_SECTION,
  },
} as const satisfies SettingsConfig
